import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { SuperAdminUser } from 'src/types/shared/SuperAdminUser';

export const fetchAllSuperAdminUsersRequest = createAction('fetchAllSuperAdminUsersRequest');
export const fetchAllSuperAdminUsersSuccess = createAction<SuperAdminUser[]>(
    'fetchAllSuperAdminUsersSuccess',
);
export const fetchAllSuperAdminUsersFailure = createAction('fetchAllSuperAdminUsersFailure');

export const fetchAllSuperAdminUsers = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchAllSuperAdminUsersRequest());
    try {
        const { data }: Response = await api.get('admin/superadmins');

        dispatch(fetchAllSuperAdminUsersSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchAllSuperAdminUsersFailure, e);
    }
};

interface Response {
    data: SuperAdminUser[];
}
